import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as workdayReportIt } from "./i18n/workday-report.lang-it";
import workdayReportSettingsLinks from "./workday-report.settings-list";
import { RouterModule } from "@angular/router";
import workdayReportRoutes from "./workday-report.routes";
import workdayReportMenu from "./workday-report.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { ArchiveReportViewComponent } from "./pages/archive-report-view/archive-report-view.component";
import { CategoriesExtraHoursComponent } from "./pages/categories-extra-hours/categories-extra-hours.component";
import { CollaboratorReportViewComponent } from "./pages/collaborator-report-view/collaborator-report-view.component";
import { SingleUserReportComponent } from "./pages/single-user-report/single-user-report.component";
import { WorkdayUsersReportsListComponent } from "./pages/staff-reports-list/workday-users-reports-list.component";
import { SingleStaffReportComponent } from "./pages/single-staff-report/single-staff-report.component";
import { ArchiveUserReportsComponent } from "./pages/my-archive/my-archive.component";
import { CollaboratorsByProviderReportsListComponent } from './pages/collaborators-by-provider-reports-list/collaborators-by-provider-reports-list.component';
import { CollaboratorsByProvidersReportComponent } from './pages/collaborators-by-providers-report/collaborators-by-providers-report.component';
import { BreadcrumbModule } from "../../layout/components/content-header/breadcrumb/breadcrumb.module";

@NgModule({
  declarations: [
    ArchiveReportViewComponent,
    CategoriesExtraHoursComponent,
    CollaboratorReportViewComponent,
    SingleUserReportComponent,
    WorkdayUsersReportsListComponent,
    SingleStaffReportComponent,
    ArchiveUserReportsComponent,
    CollaboratorsByProviderReportsListComponent,
    CollaboratorsByProvidersReportComponent,
  ],
  imports: [
    RouterModule.forChild(workdayReportRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    BreadcrumbModule,
  ],
})
export class WorkdayReportModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("workday-report", workdayReportIt, workdayReportMenu, workdayReportSettingsLinks);
  }
}
